type SkeletonProps = {
  className?: string;
};

function Skeleton({ className = '' }: SkeletonProps) {
  return (
    <div
      role="status"
      aria-label="Lädt"
      className={`animate-pulse bg-ink-100 rounded-md ${className}`}
    />
  );
}

export function AssetGridSkeleton({ count = 10 }: { count?: number }) {
  return (
    <div
      className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4"
      aria-busy="true"
    >
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="aspect-[4/3] flex flex-col">
          <Skeleton className="flex-1" />
          <Skeleton className="mt-2 h-3 w-3/4" />
        </div>
      ))}
    </div>
  );
}


/**
 * Collection-Card-Skeleton mit 2×2 Mosaic-Placeholder oben + text-zeilen.
 * Pattern mirrored auf CollectionCardMosaic-Layout (Sprint B PR-B1 DK-12).
 */
export function CollectionListSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div
      className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4"
      aria-busy="true"
    >
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="bg-white rounded-xl border border-ink-200 overflow-hidden"
        >
          <div className="grid grid-cols-2 gap-px bg-ink-200 aspect-[2/1]">
            <Skeleton className="rounded-none" />
            <Skeleton className="rounded-none" />
            <Skeleton className="rounded-none" />
            <Skeleton className="rounded-none" />
          </div>
          <div className="p-5 space-y-2">
            <Skeleton className="h-5 w-2/3" />
            <Skeleton className="h-3 w-full" />
            <Skeleton className="h-3 w-4/5" />
            <div className="flex gap-2 pt-1">
              <Skeleton className="h-3 w-16" />
              <Skeleton className="h-3 w-12" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
